/**
 * Ce que la page sait d'OBS : `window.obsstudio`, que seul le navigateur d'OBS pose. Dans un navigateur
 * ordinaire il n'existe pas.
 */
export type Obs = {
  getCurrentScene?: (rappel: (scene: { name?: unknown }) => void) => void;
};

/** `window.obsstudio`, ou `undefined` hors d'OBS. */
export function obsDeLaPage(): Obs | undefined {
  const obs = (window as unknown as { obsstudio?: Obs }).obsstudio;
  return typeof obs === "object" && obs !== null ? obs : undefined;
}

/** Le nom d'une scene dans le `detail` d'un `obsSceneChanged`, ou `null` si l'evenement n'en porte pas. */
export function nomDeScene(evenement: Event): string | null {
  const detail = (evenement as CustomEvent<{ name?: unknown } | undefined>).detail;
  const nom = detail?.name;
  return typeof nom === "string" && nom !== "" ? nom : null;
}
